export default __webpack_public_path__ + "static/media/btn-zeroback-start-na_en@2x.16124334.png";